import { Transform, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { splitCommaSeparatedIds } from '../common/comma-separated-ids.transform';

/**
 * Tetto di id per una singola chiamata batch: copre ampiamente le liste reali
 * (attrezzature, aree, punti) e tiene la query string sotto i ~4 KB.
 */
export const QR_BINDINGS_BY_TARGETS_MAX_IDS = 100;

/**
 * Query di `GET /qr-bindings/by-targets?type=…&ids=a,b`. Il `type` resta una
 * stringa: lo restringe il controller con la stessa allowlist di `by-target`.
 */
export class QrBindingsByTargetsQueryDto {
  @IsString()
  type!: string;

  @Transform(({ value }) => splitCommaSeparatedIds(value))
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(QR_BINDINGS_BY_TARGETS_MAX_IDS)
  @IsUUID('all', { each: true })
  ids!: string[];
}

export class QrBindingForTargetDto {
  @IsString()
  targetId!: string;

  @IsString()
  @IsOptional()
  qrUuid!: string | null;
}

export class QrBindingsByTargetsResponseDto {
  @ValidateNested({ each: true })
  @Type(() => QrBindingForTargetDto)
  bindings!: QrBindingForTargetDto[];
}
